export default __webpack_public_path__ + "static/media/Excavator-Basic.07be9c79.png";